import { render, staticRenderFns } from "./MyTags.vue?vue&type=template&id=38b79844&scoped=true"
import script from "./MyTags.vue?vue&type=script&lang=js"
export * from "./MyTags.vue?vue&type=script&lang=js"
import style0 from "./MyTags.vue?vue&type=style&index=0&id=38b79844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b79844",
  null
  
)

export default component.exports